const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://api-fresh-chat-existing-checkout-20260716-121401.agenticwings.com";

export default API_BASE_URL;
